import React from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { generateKeyForElement } from '../../../helpers/elementKeyHelper';
import { applyComponentTheme } from '../../../theme';
import { Grid, GridItemProps } from '../../Grid';
import { InfoCardProps } from '../../InfoCard';
import { InfoCardContent } from '../../InfoCard/InfoCard';
import { evenlySplitInfoCardGridItemProps } from '../layout';
import {
  EvenlySplitInfoCardGridItem,
  Heading,
  InfoCardContainer,
  InfoCardsContainer,
} from './styles';

export type EvenlySplitInfoCardProps = {
  infoCards: InfoCardProps[];
  heading?: string;
  infoCardGridItemProps?: GridItemProps;
} & ComponentProps;

const EvenlySplitInfoCard: React.FC<EvenlySplitInfoCardProps> = ({
  infoCards,
  heading,
  infoCardGridItemProps,
  ...props
}) => {
  const columnsByBreakpoint: GridItemProps = {
    desktop: infoCardGridItemProps?.desktop ?? evenlySplitInfoCardGridItemProps.desktop,
    tabletLandscape:
      infoCardGridItemProps?.tabletLandscape ??
      evenlySplitInfoCardGridItemProps.tabletLandscape,
    tabletPortrait:
      infoCardGridItemProps?.tabletPortrait ??
      evenlySplitInfoCardGridItemProps.tabletPortrait,
    mobile: infoCardGridItemProps?.mobile ?? evenlySplitInfoCardGridItemProps.mobile,
  };
  return (
    <Grid {...componentProps(props)}>
      <EvenlySplitInfoCardGridItem {...columnsByBreakpoint} focusable>
        {heading && <Heading>{heading}</Heading>}
        <InfoCardsContainer>
          {infoCards.map((infoCard, index) => (
            <InfoCardContainer
              key={generateKeyForElement(infoCard)}
              numberOfItems={infoCards.length}
              data-testid={`InfoCard${index}`}>
              <InfoCardContent {...infoCard} useHeadingAsH4={!!heading} />
            </InfoCardContainer>
          ))}
        </InfoCardsContainer>
      </EvenlySplitInfoCardGridItem>
    </Grid>
  );
};

export default applyComponentTheme(EvenlySplitInfoCard, 'EvenlySplitInfoCard');
